import { Label as ChordsLabel } from '~/chords/Label';

import { withClassNameHoc } from '../WithClassNameHoc';

export const Label = withClassNameHoc(ChordsLabel);
